import {useMutation} from "@tanstack/react-query";
import {correctCustomerOfferOutcomeMutationOptions} from "./correct-customer-offer-outcome.mutation-options";

export function useCorrectCustomerOfferOutcome() {
  return useMutation(correctCustomerOfferOutcomeMutationOptions());
}
